import { render, staticRenderFns } from "./FieldArea.vue?vue&type=template&id=10d572fb&scoped=true"
import script from "./FieldArea.vue?vue&type=script&lang=js"
export * from "./FieldArea.vue?vue&type=script&lang=js"
import style0 from "./FieldArea.vue?vue&type=style&index=0&id=10d572fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d572fb",
  null
  
)

export default component.exports